export default {
  en: {
    title: 'Abandon reasons',
    subtitle: 'List of abandon reasons.',
    form: {
      label: {
        label: 'Visible name',
        error: 'Enter a valid abandon reason.',
        hint: 'The abandon reason will be visible by your customers.',
      },
      name: {
        label: 'Integration ID',
        error: 'Please enter a integration id.',
        hint: 'This is the id of integration will be send on webhooks.',
      },
      visibility: {
        label: 'Visibility',
        hint: 'Select if you want this abandon reason will be visible for your customers.',
      },
    },
    messages: {
      success: 'Abandon reason {action} successfully',
    }
  },
  es: {
    title: 'Razones de abandono',
    subtitle: 'Listado de razones de abandono.',
    form: {
      label: {
        label: 'Nombre visible',
        error: 'Ingresa una razón de abandono válida.',
        hint: 'Nombre de la razón de abandono que será visible por tus clientes.',
      },
      name: {
        label: 'ID integración',
        error: 'Por favor ingrese el id de integración.',
        hint: 'Este es un id de integración el cual será enviado en webhooks.',
      },
      visibility: {
        label: 'Visibilidad',
        hint: 'Selecciona si deseas que la razón de abandono será visible por sus cliente o no.',
      },
    },
    messages: {
      success: 'Razón de abandono {action} correctamente',
    }
  },
  fr: {
    title: 'Raisons d’abandon',
    subtitle: 'Liste des raisons d’abandon.',
    form: {
      label: {
        label: 'Nom visible',
        error: 'Veuillez entrer une raison d’abandon valide.',
        hint: 'La raison d’abandon sera visible par vos clients.',
      },
      name: {
        label: 'ID d’intégration',
        error: 'Veuillez entrer un ID d’intégration.',
        hint: 'C’est l’ID d’intégration qui sera envoyé via les webhooks.',
      },
      visibility: {
        label: 'Visibilité',
        hint: 'Sélectionnez si vous souhaitez que cette raison d’abandon soit visible pour vos clients.',
      },
    },
    messages: {
      success: 'La raison d’abandon a été {action} avec succès',
    }
}

};
